export default "__VITE_ASSET__CbhW1f5w__"